import { TextField, Autocomplete } from "@mui/material";
import { useState, useRef, useEffect } from "react";

export default function SearchAddressComponent({
	setSelectedLocation,
	londonBounds,
}) {
	const [openSuggestionsContainer, setOpenSuggestionsContainer] = useState(false); // prettier-ignore
	const [searchSuggestions, setSearchSuggestions] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const autocompleteRef = useRef();

	const searchAddress = async (value = null) => {
		let currentSearchTerm;
		if (typeof value === "string") {
			currentSearchTerm = value;
		} else {
			currentSearchTerm = searchTerm;
		}
		if (currentSearchTerm !== "") {
			try {
				const response = await fetch(
					`https://nominatim.openstreetmap.org/search?format=json&q=${currentSearchTerm}&bounded=1&viewbox=${londonBounds[0][1].toString()},${londonBounds[0][0].toString()},${londonBounds[1][1].toString()},${londonBounds[1][0].toString()}`
				);
				if (response.ok) {
					let data = await response.json();
					setSearchSuggestions(data);
					setOpenSuggestionsContainer(true);
				}
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		}
	};

	const handleChange = (e, newValue) => {
		if (typeof newValue === "object") {
			setOpenSuggestionsContainer(false);
			if (newValue) {
				setSelectedLocation(newValue);
			} else {
				setSelectedLocation("");
			}
		}
	};

	const handleKeyDown = (e) => {
		if (e.keyCode === 13) {
			// Check if Enter key is pressed (keyCode 13)
			setSearchTerm(e.target.value);
			searchAddress(e.target.value);
		}
	};

	const handleUserClick = (e) => {
		const ref = autocompleteRef.current;
		setOpenSuggestionsContainer(
			ref ? !openSuggestionsContainer && ref.contains(e.target) : false
		);
	};

	useEffect(() => {
		document.addEventListener("click", handleUserClick);
		return () => {
			document.removeEventListener("click", handleUserClick);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [openSuggestionsContainer]);

	return (
		<>
			<Autocomplete
				clearOnBlur={false}
				filterOptions={(option) => option}
				freeSolo={searchSuggestions.length === 0}
				fullWidth
				getOptionLabel={(option) => typeof option === "object" ? option["display_name"] : option} // prettier-ignore
				noOptionsText={"No search results found"}
				onChange={handleChange}
				open={openSuggestionsContainer}
				options={searchSuggestions}
				ref={autocompleteRef}
				onKeyDown={handleKeyDown}
				renderOption={(props, option) => {
					if (typeof option === "object") {
						return (
							<li {...props} key={option.place_id}>
								{option.display_name}
							</li>
						);
					} else {
						return;
					}
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Insert the address of your interest in London"
						className="autocomplete-field"
						variant="outlined"
						onBlur={(e) => {
							setSearchTerm(e.target.value);
						}}
						size="small"
						value={"searchDisplayValue"}
						fullWidth
						helperText="The list of services will be sorted by proximity to the searched address."
					/>
				)}
			/>
			<button
				type="submit"
				id="address_search_button"
				onClick={searchAddress}
			>
				Search
			</button>
		</>
	);
}
